import { render, staticRenderFns } from "./ResearcherClaimInput.vue?vue&type=template&id=53d3b1f8&scoped=true&"
import script from "./ResearcherClaimInput.vue?vue&type=script&lang=js&"
export * from "./ResearcherClaimInput.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherClaimInput.vue?vue&type=style&index=0&id=53d3b1f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3b1f8",
  null
  
)

export default component.exports